import { takeLatest, put, all, call } from 'redux-saga/effects';

import PostAuditingToolReportActionTypes from './post-auditing-tool-report.types';

import {
	postAuditingToolReportListGet,
	postAuditingToolReportExcelListGet,
} from './post-auditing-tool-report.service';

import {
	getPostAuditingToolReportDetailsSuccess,
	getPostAuditingToolReportDetailsFailure,
	getPostAuditingToolReportDetailsResponseChanged,
	fetchPostAuditingToolReportExcelSuccess,
	fetchPostAuditingToolReportExcelFailure,
	fetchPostAuditingToolReportResponseExcelResetChanged,
} from './post-auditing-tool-report.action';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET POST AUDITING TOOL REPORT DETAILS  ******************** */
export function* getPostAuditingToolReportList({ payload }: any) {
	try {
		const key = 'GetPostAuditingToolReportKey';
		const jsonData = {
			companyID: payload.companyID,
			branchID: payload.BranchID,
			centerID: payload.CenterID,
			DatabaseName: payload.DatabaseName,
			fromDate: payload.fromDate,
			toDate: payload.toDate,
			userID: payload.UserID,
			Userlevel: payload.UserLevel,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(postAuditingToolReportListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPostAuditingToolReportDetailsFailure(responseData.data));
		} else {
			yield put(getPostAuditingToolReportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPostAuditingToolReportDetailsFailure(error));
	}
}

export function* resetgetPostAuditingToolReportListResponse() {
	yield put(getPostAuditingToolReportDetailsResponseChanged());
}

export function* onGetPostAuditingToolReportListDetails() {
	yield takeLatest(
		PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_LIST_START,
		getPostAuditingToolReportList,
	);
}

export function* onGetPostAuditingToolReportListResponseReset() {
	yield takeLatest(
		PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_LIST_RESPONSE_RESET,
		resetgetPostAuditingToolReportListResponse,
	);
}
/** *********************  END GET POST AUDITING TOOL REPORT DETAILS ******************** */

/** *********************  START GET MEMBER DETAILS EXCEL REPORT  ******************** */
export function* getPostAuditingToolReportExcelList({ payload }: any) {
	try {
		const key = 'PostAuditingToolReportExport';
		const jsonData = {
			companyID: payload.companyID,
			branchID: payload.BranchID,
			centerID: payload.CenterID,
			DatabaseName: payload.DatabaseName,
			FromDate: payload.FromDate,
			ToDate: payload.ToDate,
			UserID: payload.UserID,
			GeneralCompanyID: payload.generalCompanyID,
			RequestID: payload.RequestID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(postAuditingToolReportExcelListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchPostAuditingToolReportExcelFailure(responseData.data));
		} else {
			yield put(fetchPostAuditingToolReportExcelSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchPostAuditingToolReportExcelFailure(error));
	}
}

export function* resetGetPostAuditingToolReportExcelListResponse() {
	yield put(fetchPostAuditingToolReportResponseExcelResetChanged());
}

export function* onGetPostAuditingToolReportExcelListDetails() {
	yield takeLatest(
		PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_EXCEL_START,
		getPostAuditingToolReportExcelList,
	);
}

export function* onGetPostAuditingToolReportExcelListResponseReset() {
	yield takeLatest(
		PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_EXCEL_RESPONSE_RESET,
		resetGetPostAuditingToolReportExcelListResponse,
	);
}
/** *********************  END GET MEMBER DETAILS EXCEL REPORT ******************** */

export function* postAuditingToolReportSaga() {
	yield all([
		call(onGetPostAuditingToolReportListDetails),
		call(onGetPostAuditingToolReportListResponseReset),
		call(onGetPostAuditingToolReportExcelListDetails),
		call(onGetPostAuditingToolReportExcelListResponseReset),
	]);
}
